<div
  #chartContainer
  data-testid="pie-chart-container"
  [class]="className"
  [style.height]="height"
  [style.width]="width"
></div>
